import React from "react";
import { motion } from "framer-motion";

const outlets = [
    "The Times of India",
    "Hindustan Times",
    "Lokmat",
    "Central Railway — Letter of Appreciation",
    "Lokmat Health Awards 2022",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {outlets.map((o, i) => (
            <span key={i} className="flex items-center">
                <span className="font-display italic text-lg md:text-2xl text-ink-800/80 whitespace-nowrap px-8 md:px-12">
                    {o}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-bisleri/50" />
            </span>
        ))}
    </div>
);

const FeaturedIn = () => {
    return (
        <section
            data-testid="featured-in"
            className="relative bg-cream border-y border-ink-900/8 py-10 md:py-14 overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-6 md:mb-8">
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="flex items-center gap-4"
                >
                    <span className="w-8 h-px bg-bisleri" />
                    <span className="font-mono text-[10px] md:text-[11px] tracking-[0.3em] uppercase text-ink-600">
                        As Featured In
                    </span>
                </motion.div>
            </div>

            {/* Edge fades */}
            <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 md:w-32 z-10 bg-gradient-to-r from-cream to-transparent" />
            <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 md:w-32 z-10 bg-gradient-to-l from-cream to-transparent" />

            <div className="relative flex" data-testid="featured-in-marquee">
                <motion.div
                    className="flex"
                    animate={{ x: ["0%", "-50%"] }}
                    transition={{ duration: 28, ease: "linear", repeat: Infinity }}
                >
                    <Row />
                    <Row />
                </motion.div>
            </div>
        </section>
    );
};

export default FeaturedIn;
